import { render } from "./BaseButton.vue?vue&type=template&id=011b0eb2&scoped=true&bindings={\"theme\":\"props\",\"width\":\"props\",\"link\":\"props\",\"to\":\"props\"}"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=011b0eb2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-011b0eb2"

export default script